import { Component, OnInit,ViewChild } from '@angular/core';
import Swal from 'sweetalert2'
import { NgForm } from '@angular/forms'


import { GetPartnerIDService } from "../../../services/donation/getPartnerID/get-partner-id.service";
import { DuplicatePartnerService } from "../../../services/contacts/duplicatePartner/duplicate-partner.service";
import { LoginService } from "../../../services/auth/login/login.service";


@Component({
  selector: 'app-duplicate-partner-mapping',
  templateUrl: './duplicate-partner-mapping.component.html',
  styleUrls: ['./duplicate-partner-mapping.component.less']
})
export class DuplicatePartnerMappingComponent implements OnInit {
  @ViewChild('correctPartnerIdData', null) correctPartnerIdData: NgForm;
  @ViewChild('wrongPartnerIdData', null) wrongPartnerIdData: NgForm;



  /**
   * Button loader variable
   */
  public correctIdSubmitLoading: Boolean = false
  public wrongIdSubmitLoading: Boolean = false
  public SubmitLoading: Boolean = false


  /**
   * assign variable
   */
  public correct = {
    isCorrect: false,
    errorID: '',
    data: ''
  }
  public wrong = {
    isWrong: false,
    errorID: '',
    data: ''
  }
  public changeDate = {
    correctID: "",
    wrongID: ""
  }

  constructor(
    private GetPartnerIDService: GetPartnerIDService,
    private DuplicatePartnerService: DuplicatePartnerService,
    private LoginService: LoginService
  ) { }

  ngOnInit() {
  }

  async correctPartnerId(val) {
    this.correctIdSubmitLoading = true
    let data = `partner_id=${val.correctID}`
    let result = await this.getPartnerIdToDetails(data)
    if (result.status == "success" && result.data != '') {
      this.correctIdSubmitLoading = false
      this.correct.isCorrect = false
      this.correct.data = result.data
      this.changeDate.correctID = val.correctID
    } else {
      this.correct.isCorrect = true
      this.correct.errorID = val.correctID
      this.correctIdSubmitLoading = false
    }

  }

  async wrongPartnerId(val) {
    this.wrongIdSubmitLoading = true
    let data = `partner_id=${val.wrongID}`
    let result = await this.getPartnerIdToDetails(data)
    if (result.status == "success" && result.data != '') {
      this.wrongIdSubmitLoading = false
      this.wrong.isWrong = false
      this.wrong.data = result.data
      this.changeDate.wrongID = val.wrongID
    } else {
      this.wrong.isWrong = true
      this.wrong.errorID = val.wrongID
      this.wrongIdSubmitLoading = false
    }
  }

  async mapPartnerID() {
    var submit = true
    this.SubmitLoading = true
    let user_id = JSON.parse(localStorage.getItem("userDetails"))
    if (user_id == undefined || user_id == null) await this.LoginService.userLogOut()

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    if (this.changeDate.correctID == '' || this.changeDate.wrongID == '') {
      submit = false
      this.SubmitLoading = false
      Toast.fire({
        icon: 'error',
        title: 'Partner ID Missing'
      })
    } else if (this.changeDate.correctID == this.changeDate.wrongID && (this.changeDate.correctID != '' || this.changeDate.wrongID != '')) {
      submit = false
      this.SubmitLoading = false
      Toast.fire({
        icon: 'warning',
        title: 'Same partner ID used'
      })
    } else if (this.wrong.isWrong == true || this.correct.isCorrect == true) {
      submit = false
      this.SubmitLoading = false
      Toast.fire({
        icon: 'error',
        title: 'Invalid Partner ID'
      })
    }
    if (submit) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.value) {
          let data = {
            "correct_partner_id": parseInt(this.changeDate.correctID),
            "wrong_partner_id": parseInt(this.changeDate.wrongID),
            "user_id": parseInt(user_id.STAFF_ID)
          }
          let res = await this.DuplicatePartnerService.removeDuplicatePartner(data)
          if (res.status == "success") {
            this.SubmitLoading = false
            this.cancel()
            Swal.fire(
              'Deleted!',
              'Partner ID has been deleted.',
              'success'
            )
          } else {
            this.SubmitLoading = false
            Swal.fire(
              'Failed!',
              'Partner ID delete Failed',
              'error'
            )
          }
        } else {
          this.SubmitLoading = false
        }
      })
    }
  }

  async cancel() {
    this.correct.isCorrect = false
    this.correct.data = ""
    this.wrong.isWrong = false
    this.wrong.data = ""
    this.correctPartnerIdData.reset()
    this.wrongPartnerIdData.reset()
  }

  async getPartnerIdToDetails(id) {
    return await this.GetPartnerIDService.getPartnerID(id)
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar) && event.keyCode != 13) {
      event.preventDefault();
    }
  }

}
